<section class="activeViewSection">
  <pp-active-view-preview [ppHideText]="ppHideText" [ppWorkspaceId]="ppWorkspaceId" />

  <pp-button
    [ppDisabled]="!saveView || !saveViewEditable"
    ppStyle="secondary"
    [ppProcess]="ppProcessing"
    (ppAction)="saveToCurrentView()"
    ppTooltip
    [ppTitle]="saveViewTooltipTitle"
  >
    {{ 'save_to_current_view' | ppTranslate }}
  </pp-button>
</section>
